import React, {useEffect} from 'react';
import {Header} from "../index";
import {SpeedDial, StickySetting, DomainLinks} from './../../components'
import { useDispatch, useSelector} from "react-redux";
import Cookies from "universal-cookie";
import {LOGOUT} from "../../types";
const cookies = new Cookies();

const Master = (props) => {

    const { children } = props;
    const dispatch = useDispatch();
    const auth = useSelector(state => state.authReducer);

    useEffect(() => {
        if (cookies.get('auth') === undefined) {
            dispatch({type: LOGOUT});
        }
    }, [cookies.get('auth')])


    if (!auth.login) {
        return null
    }

    return(
        <div className={'master'}>
            <Header />
            <div className={'master-inner'}>
                {children}
            </div>
            {auth.user.permissions.setting && Boolean(auth.user.permissions.setting.get_setting_admin.access) && <SpeedDial />}
            {/* sticky setting dialog */}
            {auth.user.permissions.setting && Boolean(auth.user.permissions.setting.get_sticky_setting_admin.access) && <StickySetting/>}
            {auth.user.permissions.setting && Boolean(auth.user.permissions.setting.get_domain_setting_admin.access) && <DomainLinks/>}
        </div>
    );
}
export default Master
